import HeroSlider from './custom-blocks/hero-slider/hero-slider';
import StatSlider from './custom-blocks/stats-slider/stats-slider';
import Testimonials from './custom-blocks/testimonials/testimonials';
import AccordionGroup from './custom-blocks/accordion/accordion';
import RcsAvailabilityMap from './custom-blocks/rcs-availability-map/rcs-availability-map';
import ContinuousSlider from './custom-blocks/full-width-slider/full-width-slider';
import SalesForceForm from './custom-blocks/sfdc-form/sfdc-form';

HeroSlider.onReady();
ContinuousSlider.onReady();
AccordionGroup.onReady();
StatSlider.onReady();
RcsAvailabilityMap.onReady();
Testimonials.onReady();
SalesForceForm.onReady();
